import {EmailingIntegration} from 'helpers/emailing'
import {get} from 'lodash'
import {IntegrationSyncStatus} from 'helpers/integrations'
import {getUser} from 'selectors/auth'
import {accountHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'

export const isXeroStatusUpdating = state => state.integration.xero.isUpdating || false

export const getXeroStatus = state => state.integration.xero.xeroStatus

export const isXeroIntegrationConnected = (state) => {
  const xeroStatus = getXeroStatus(state)
  return get(xeroStatus, 'status.id', 0) === IntegrationSyncStatus.OK
}

export const isQuickBooksStatusUpdating = state => state.integration.quickBooks.isUpdating || false

export const getQuickBooksStatus = state => state.integration.quickBooks.quickBooksStatus

export const getMailchimp = state => state.integration.mailchimp

export const getMailchimpStatus = state => getMailchimp(state).mailchimpStatus

export const isMailchimpConnected = (state) => {
  const mailchimpStatus = getMailchimpStatus(state)
  return get(mailchimpStatus, 'status.id', 0) === IntegrationSyncStatus.OK
}

export const getHubspot = state => state.integration.hubspot

export const getHubspotStatus = state => getHubspot(state).hubspotStatus

export const isHubspotConnected = (state) => {
  const user = getUser(state)
  const hubspotStatus = getHubspotStatus(state)
  return (
      get(hubspotStatus, 'status.id', 0) === IntegrationSyncStatus.OK &&
      accountHasFeature(user, features.HUBSPOT_SYNC)
  )
}

export const getEmailingIntegration = (state, emailingIntegration) => {
  switch (emailingIntegration) {
    case EmailingIntegration.HUBSPOT:
      return getHubspot(state)
    case EmailingIntegration.MAILCHIMP:
      return getMailchimp(state)
    default:
      return []
  }
}

export const getOneDrive = state => state.integration.oneDrive
export const getOneDriveStatus = state => getOneDrive(state).oneDriveStatus

export const getSharePoint = state => state.integration.sharePoint
export const getSharePointStatus = state => getSharePoint(state).sharePointStatus

export const getShopify = state => state.integration.shopify

export const getShopifyStatus = state => getShopify(state).shopifyStatus

export const getDocumentSites = state => state.integration.document.sites
export const getDocumentBaseSite = state => state.integration.document.baseSite
export const getDocumentDrives = state => state.integration.document.drives
export const getDocumentBaseDrive = state => state.integration.document.baseDrive
export const getDocumentFolders = state => state.integration.document.folders
export const getDocumentBaseFolder = state => state.integration.document.baseFolder

export const isBaseSiteSet = state => state.integration.document.isBaseSiteSet
export const isBaseDriveSet = state => state.integration.document.isBaseDriveSet
export const isBaseFolderSet = state => state.integration.document.isBaseFolderSet

export const isLoadingFolders = state => state.integration.document.isLoadingFolders
export const getDocumentUploadUrl = state => state.integration.document.uploadUrl

export const getSageProviderData = state => state.integration.sage.provider
export const isSageProviderEnabling = state => state.integration.sage.isEnabling

export const getZohoStatus = state => state.integration.zoho.status
export const getZohoOrganisations = state => state.integration.zoho.organisations || []
export const getZohoWorkspaces = state => state.integration.zoho.workspaces || []
export const getZohoRecords = state => state.integration.zoho.records
export const isZohoConnecting = state => state.integration.zoho.connecting
export const getZohoConnectStep = state => state.integration.zoho.connectStep
export const isZohoChangeRangeSelecting = state => state.integration.zoho.changeRangeSelecting
export const isZohoReauthorising = state => state.integration.zoho.reauthorising
export const isZohoAuthenticating = state => state.integration.zoho.authenticating
export const isZohoActivating = state => state.integration.zoho.activating
export const isZohoDeactivating = state => state.integration.zoho.deactivating
export const isZohoChangingRange = state => state.integration.zoho.changingRange
export const isZohoGettingOrganisations = state => state.integration.zoho.gettingOrganisations
export const isZohoGettingWorkspaces = state => state.integration.zoho.gettingWorkspaces
export const isZohoGettingRecords = state => state.integration.zoho.gettingRecords
export const getZohoAuthError = state => state.integration.zoho.authenticationError
export const getZohoActivationError = state => state.integration.zoho.activationError
export const getZohoChangeRangeError = state => state.integration.zoho.changeRangeError
export const getZohoPlan = state => state.integration.zoho.plan
export const getZohoOrganisationId = state => state.integration.zoho.organisationId
export const getZohoWorkspaceId = state => state.integration.zoho.workspaceId
export const getZohoSelectedTables = state => state.integration.zoho.selectedTables
